module.exports = __webpack_public_path__ + "media/Undying Souls (Valzeon Passage).8361a4d0.mp3";